export const containerStyle = {
    my: "1rem",
    minHeight: "calc(100vh - 2rem)",
    display: "grid",
    placeItems: "center",
};

export const weatherBoxStyle = {
    maxWidth: "600px",
    width: "100%",
    px: { xs: 3, sm: 5 },
    py: { xs: 4, sm: 6 },
    textAlign: "center",
    bgcolor: "rgba( 255, 255, 255, 0.15 )",
    border: "1px solid rgba( 255, 255, 255, 0.18 )",
    borderRadius: "16px",
    boxShadow: "0 8px 30px 0 rgba(31, 38, 135, 0.37)",
    backdropFilter: "blur(8.5px)",
    overflow: "hidden",
};